import { GLOBAL_SET_DATA } from '../actions';

const INIT_STATE = {
    producto: [],
    subproducto: [],
    oficina: [],
    regional: [],
    departamentos_regional: '',
};

const globalsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GLOBAL_SET_DATA:
            return { ...state, ...action.payload };
        default:
            return { ...state };
    }
};

export default globalsReducer;
